import React from 'react';
import { Drawer } from 'antd';
import "../../../../src/pages/assets/cssModules/pages/pages.css"; 
import "./styled.scss"



export const CustomDrawer = ({ open, onClose, content }) => (
  <Drawer
    open={open}
    onClose={onClose}
    placement="right"
    destroyOnClose
    closeIcon={null} 
    className="supportdrawer"
    styles={{
      wrapper: { maxWidth: '750px'}
    }}
  >
    {content}
  </Drawer>
);